import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Card } from '@otp/ui';
import { useQuery } from '@apollo/client';
import Grid from '@mui/material/Grid';
import { Link } from 'src/components/common/link';
import {
  UserWithStoresCountQuery,
  UserWithStoresCountDocument,
} from 'src/graphql/generated/graphql';
import { Routes } from 'src/components/common/router/constants';
import { ViewType } from 'src/components/manage-restaurants/list/view-switcher';
import MapImage from './map.png';
import { useDeviceContext } from 'src/context/device.context';
import { StoreOutline } from '@otp/icons';

export const RestaurantMap = ({ className }: { className?: string }) => {
  const { t } = useTranslation();

  const { data } = useQuery<UserWithStoresCountQuery>(
    UserWithStoresCountDocument,
    {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-and-network',
    },
  );
  const userWithScoresCount = data?.currentUser;

  const storesCount = userWithScoresCount?.storesCount || 0;
  const allStoresCount = userWithScoresCount?.allStoresCount || 0;

  return (
    <Link
      to={Routes.restaurants.path}
      queryParams={{
        view: ViewType.Map,
      }}
    >
      <Card
        className="bg-[#F8F9FD] p-6 border-none flex flex-col w-full"
        isLink
        linkPosition="top"
        linkIconClassName="mt-[18px]"
      >
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Grid container alignItems="center" spacing={2}>
              <Grid item>
                <StoreOutline />
              </Grid>
              <Grid item>
                <Typography
                  component="div"
                  variant="body1"
                  fontWeight="medium"
                  fontFamily="Inter"
                  className="font-semibold"
                >
                  {t('my-organisation.my-stores')}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Typography fontWeight="bold" variant="h5" fontFamily="Inter">
              {`${storesCount.toLocaleString()} ${t('of')} ${allStoresCount.toLocaleString()}`}
            </Typography>
          </Grid>
        </Grid>

        {/* Map Image Section */}
        <Grid item className="mt-2 w-full overflow-hidden">
          {/* eslint-disable-next-line */}
          <img
            src={MapImage}
            alt="Map"
            className="object-cover rounded-xl w-full h-[200px]"
          />
        </Grid>
      </Card>
    </Link>
  );
};
